var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msupeript"},[_c('input',{staticClass:"ipt",attrs:{"type":_vm.type,"readonly":_vm.readonly},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }